import './index.css'

function TwoGrid({item1,item2}){
    return <div className='two-grid'>
    {item1}
    {item2}
    </div>
}

export default TwoGrid